<template>
  <div class="frame">
    <hr
        v-for="hour in lines"
        :key="hour"
        class="line"
    >
  </div>
</template>

<script>
export default {
  name: 'Frame',

  props: {
    lines: Number,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

  .frame {
    height: inherit;
    min-width: 100%;
    padding-top: 31px;
    pointer-events: none;
    position: fixed;
    width: calc(100% - 15px);
    z-index: 20;
  }

  .line {
    margin-top: 29px;
    border: None;
    background-color: $grey;
    height: 1px;
  }

  .line:nth-child(2n){
    background-color: $light-grey;
    height: 1px;
  }

</style>
